export const deliveryInfos = {
  overline: 'Informations',
  title: 'Livraison',
  lead: `Nos délais d'expédition et nos frais de port, pour la France et le reste de l'Europe.`,
  blocks: [
    {
      title: `Expédition`,
      text: `Les commandes Lacana CBD sont expédiées sous 24 à 48h ouvrés.`
    },
    {
      title: `Délais d'acheminement`,
      text: `Le délai d'acheminement est de 1 à 3 jours vers la France et de 2 à 7 jours ouvrés vers le reste de l'Europe.`
    },
    {
      title: `Frais de port`,
      text: `La livraison est offerte à partir de 50€ pour la France et 70€ vers le reste de l'Europe.`
    }
  ]
};
